var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchiconStroke = function SvgSearchiconStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0593 16.5858C21.8404 15.8047 23.1067 15.8047 23.8877 16.5858L44.5184 37.2164C46.4929 39.191 46.4931 42.3965 44.5234 44.3662L44.3662 44.5234C42.3916 46.4981 39.1938 46.4958 37.2164 44.5184L16.5858 23.8877C15.8047 23.1067 15.8047 21.8404 16.5858 21.0593L21.0593 16.5858ZM20.8284 22.4735L40.0449 41.69C40.4635 42.1086 41.1286 42.1042 41.5378 41.695L41.695 41.5378C42.1002 41.1326 42.1048 40.4597 41.69 40.0449L22.4735 20.8284L20.8284 22.4735Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 34C27.2843 34 34 27.2843 34 19C34 10.7157 27.2843 4 19 4C10.7157 4 4 10.7157 4 19C4 27.2843 10.7157 34 19 34Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 19C2 9.61116 9.61116 2 19 2C28.3888 2 36 9.61116 36 19C36 28.3888 28.3888 36 19 36C9.61116 36 2 28.3888 2 19ZM19 6C11.8203 6 6 11.8203 6 19C6 26.1797 11.8203 32 19 32C26.1797 32 32 26.1797 32 19C32 11.8203 26.1797 6 19 6Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchiconStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/searchicon-stroke.3467c4eb.svg";
export { ForwardRef as ReactComponent };